import { useTranslation } from 'react-i18next'
import flatten from 'lodash-es/flatten'

import {
  EMPTY_OBJECT,
  FLOATING_ELEMENT_PLACEMENT,
} from '../../../../constants/common'
import { htmlToPlainText } from '../../../../utils/html'
import { EntityTag } from '../../../Entity'
import { TAG_HEIGHT } from '../../../Tag'
import Text from '../../../Text'
import {
  useEmailProfileMessageAttachedFiles,
  useEmailProfileMessageAttachedRequests,
} from '../EmailProfileMessage.hooks'

import * as styles from './EmailProfileMessageCollapsedHeaderSenderAdditionalInfo.module.css'

import AttachFilesIcon from '../../../../icons/attach.svg'
import CopyIcon from '../../../../icons/email-copy.svg'
import RelatedRequestsIcon from '../../../../icons/service-request.svg'

function EmailProfileMessageCollapsedHeaderSenderAdditionalInfo({
  className = styles.EmailProfileMessageCollapsedHeaderSenderAdditionalInfo,
  data,
  filePreviewProps,
  getFilesApi,
  onCloseModal,
  onSetModal,
}) {
  const { t } = useTranslation()

  const {
    archive_copy_entities: archiveCopyEntities = EMPTY_OBJECT,
    files,
    linked_requests: linkedRequests,
    text,
    uuid,
  } = data

  const plainText = htmlToPlainText(text)

  const copyToLength = flatten(Object.values(archiveCopyEntities)).length

  const { handleClickFileTag } = useEmailProfileMessageAttachedFiles({
    filePreviewProps,
    getFilesApi,
    uuid,
    onCloseModal,
    onSetModal,
  })

  const { handleClickAttachedRequests } =
    useEmailProfileMessageAttachedRequests({
      uuid,
      onCloseModal,
      onSetModal,
    })

  return (
    <div className={className}>
      <Text className={styles.text}>{plainText}</Text>
      <div className={styles.tags}>
        {/* #TODO Tags are similar to tables, probably worth moving to a common component */}
        {files.length > 0 ? (
          <EntityTag
            Icon={AttachFilesIcon}
            className={styles.tag}
            height={TAG_HEIGHT.height28}
            name={`${t('Common.AttachedFilesTagTextKey')} ${files.length}`}
            tooltip={t('Common.AttachedFilesTagTooltipTextKey', {
              count: files.length,
            })}
            tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
            onClick={handleClickFileTag}
          />
        ) : null}
        {linkedRequests.length > 0 ? (
          <EntityTag
            Icon={RelatedRequestsIcon}
            className={styles.tag}
            height={TAG_HEIGHT.height28}
            name={`${t('Common.AttachedRequestsTagTextKey')} ${linkedRequests.length}`}
            tooltip={t('Common.AttachedRequestsTagTooltipTextKey', {
              count: linkedRequests.length,
            })}
            tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
            onClick={handleClickAttachedRequests}
          />
        ) : null}
        {copyToLength > 0 ? (
          <EntityTag
            Icon={CopyIcon}
            className={styles.tag}
            height={TAG_HEIGHT.height28}
            name={`${t('Common.AttachedCopiesTagTextKey')} ${copyToLength}`}
            tooltip={t('Common.AttachedCopiesTagTooltipTextKey', {
              count: copyToLength,
            })}
            tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
          />
        ) : null}
      </div>
    </div>
  )
}

export default EmailProfileMessageCollapsedHeaderSenderAdditionalInfo
